import React, { useEffect, useState } from "react";
import { doc, updateDoc, collection, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
import Menu from "@mui/material/Menu";

import { db } from "../../../../firebase";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BasicListElements from "../../../../components/BasicListElements/BasicListElements";
import { Box, Typography } from "@mui/material";
import {
  fetcherCompanies,
  fetcherRoles,
} from "../../../../utils/FectcherData/FectcherUser";
import { DataGrid } from "@mui/x-data-grid";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ReusableForm from "../../../../components/ReusableForm/ReusableForm";
import ReusableFormEdit from "../../../../components/ReusableFormEdit/ReusableFormEdit";
import DownloadIcon from "@mui/icons-material/Download";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Button } from "@mui/material";
import ReusableVewData from "../../../../components/ReusableVewData/ReusableVewData";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import generateReportByData from "../../../../utils/Reports/generateReportByData";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
const useStyles = makeStyles({
  root: {
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#1e2158",
      color: "white",
    },
    "& .MuiDataGrid-row:nth-child(odd)": {
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Ajusta la opacidad para filas impares en hover
      },
      "&:focus": {
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Ajusta la opacidad para filas impares en hover
      },
    },
    "& .MuiDataGrid-row:nth-child(even)": {
      backgroundColor: "lightgray",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Ajusta la opacidad para filas impares en hover
      },
      "&:focus": {
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Ajusta la opacidad para filas impares en hover
      },
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "rgba(255, 255, 255, 0.9) !important",
    },
  },
});

const AdminCompanies = () => {
  const navigate = useNavigate();
  const [bodyItems, setBodyItems] = useState([]);
  const [render, setRender] = useState(false);
  const [columns, setColum] = useState([]);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [initialValues, setInitialValues] = useState(false);
  const [statusActive, setStatusActive] = useState(false);

  // estados formualrios

  const classes = useStyles();
  useEffect(() => {
    getData();
  }, [render]);

  const getData = async () => {
    const orders = await fetcherCompanies();
    const sortedOrders = orders.sort((a, b) => {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    console.log(sortedOrders);
    setBodyItems(sortedOrders);
  };

  useEffect(() => {
    upDateTable();
  }, [bodyItems]);

  const handleView = (row) => {
    console.log("Ver", row);
    setInitialValues(row);
    setOpen(true);
  };
  const handleEdit = (row) => {
    console.log("Editar", row);
    setInitialValues(row);
    setOpenEdit(true);
  };
  const handleActivate = async (row) => {
    row.stausService = true;
    setStatusActive(true);
    try {
      const collRef = collection(db, process.env.REACT_APP_COL_COMPANIES);
      const docRef = doc(collRef, row.id);
      await updateDoc(docRef, { stausService: true });
      console.log("Documento actualizado con éxito.");
    } catch (error) {
      console.log(error);
    }
  };
  const handleDeactivate = async (row) => {
    row.stausService = false;
    setStatusActive(false);
    try {
      const collRef = collection(db, process.env.REACT_APP_COL_COMPANIES);
      const docRef = doc(collRef, row.id);
      await updateDoc(docRef, { stausService: false });
      console.log("Documento actualizado con éxito.");
    } catch (error) {
      console.log(error);
    }
  };

  const sincronizeCompany = async (row) => {
    const collRef = collection(db, process.env.REACT_APP_COL_COMPANIES);
    const docRef = doc(collRef, row.id);
    let documenCompany = await getDoc(docRef);
    let companiExpress = documenCompany.data();
    console.log(companiExpress.integrationServicesBicciID);
    console.log(companiExpress.integrationServicesBicciIsActive);

    if (
      companiExpress.integrationServicesBicciID &&
      companiExpress.integrationServicesBicciIsActive
    ) {
      const collRefBicci = collection(
        db,
        process.env.REACT_APP_COL_BICCI_COMPANIES
      );
      const docRefBicci = doc(
        collRefBicci,
        companiExpress.integrationServicesBicciID
      );
      let documenCompanBicci = await getDoc(docRefBicci);
      let companiBicci = documenCompanBicci.data();
      console.log(companiBicci);
    }

    console.log("sincornizar integracion");
  };

  const upDateTable = () => {
    const renderActionButtons = (params) => (
      <Box sx={{ minWidth: "200px" }}>
        {/* Botón Ver */}
        <IconButton
          sx={{ width: "30px !important", color: "#1e2158 !important" }}
          aria-label="ver"
          onClick={() => handleView(params.row)}
        >
          <VisibilityIcon />
        </IconButton>
        {/* Botón Editar */}
        <IconButton
          aria-label="editar"
          onClick={() => handleEdit(params.row)}
          sx={{ width: "30px !important", color: "#1e2158 !important" }}
        >
          <EditIcon />
        </IconButton>

        <IconButton
          sx={{ width: "30px !important", color: "#1e2158 !important" }}
          aria-label="ver"
          onClick={() =>
            navigate(`/dashboard/management-companies/${params.row.id}`)
          }
        >
          <NoteAltIcon />
        </IconButton>
        {/* Botón Activar/Desactivar */}
        {params.row.stausService ? (
          <IconButton
            sx={{
              width: "50px !important",
              color: "#21ba45 !important",
            }}
            aria-label="desactivar"
            onClick={() => handleDeactivate(params.row)}
          >
            <ToggleOffIcon sx={{ fontSize: "40px" }} />
          </IconButton>
        ) : (
          <IconButton
            sx={{
              width: "50px !important",
              color: "#1e2158 !important",
            }}
            aria-label="activar"
            onClick={() => handleActivate(params.row)}
          >
            <ToggleOnIcon sx={{ fontSize: "40px" }} />
          </IconButton>
        )}
      </Box>
    );
    const renderActionUpdate = (params) => (
      <Box sx={{ minWidth: "200px" }}>
        <IconButton
          sx={{ width: "30px !important", color: "#1e2158 !important" }}
          aria-label="ver"
          onClick={() => sincronizeCompany(params.row)}
        >
          <CloudSyncIcon />
        </IconButton>
      </Box>
    );

    const columnsTable = [
      {
        field: "actions",
        headerName: "Acciones",
        width: 200,
        renderCell: renderActionButtons,
        sortable: false,
        filterable: false,
      },
      {
        field: "id",
        headerName: "ID",
        width: 150,
        editable: true,
      },
      {
        field: "companyName",
        headerName: "companyName",
        width: 250,
        editable: true,
      },
      {
        field: "companyRut",
        headerName: "companyRut",
        width: 100,
      },
      {
        field: "companyContacEmail",
        headerName: "companyContacEmail",
        width: 200,
      },
      {
        field: "companyAdressPhone",
        headerName: "companyAdressPhone",
        width: 200,
      },
      {
        field: "companyActividad",
        headerName: "companyActividad",
        width: 300,
      },
      {
        field: "Sincronizar",
        headerName: "Sincronizar",
        width: 70,
        renderCell: renderActionUpdate,
        sortable: false,
        filterable: false,
      },
    ];

    setColum(columnsTable);

    var rows = [];

    for (var i = 0; i < bodyItems.length; i++) {
      rows.push({
        id: bodyItems[i].id,
        companyName: bodyItems[i].companyName,
        companyRut: bodyItems[i].companyRut,
        companyContacEmail: bodyItems[i].companyContacEmail,
        companyAdressPhone: bodyItems[i].companyAdressPhone,
        companyActividad: bodyItems[i].companyActividad,
        stausService: bodyItems[i].stausService,
        integrationServicesBicciID: bodyItems[i].integrationServicesBicciID,
      });
    }
    setRows(rows);
  };

  // Formolario Nuevo Item
  const formFields = [
    { variable: "id", label: "id", type: "string" },
    { variable: "companyName", label: "companyName", type: "string" },
    {
      variable: "companyContacEmail",
      label: "companyContacEmail",
      type: "string",
    },
    {
      variable: "companyAdressPhone",
      label: "companyAdressPhone",
      type: "string",
    },
    { variable: "companyActividad", label: "companyActividad", type: "string" },
    { variable: "stausService", label: "stausService", type: "string" },
    {
      variable: "integrationServicesBicciID",
      label: "integrationServicesBicciID",
      type: "string",
    },
    {
      variable: "integrationServicesBicciIsActive",
      label: "integrationServicesBicciIsActive",
      type: "boolean",
    },
  ];
  const handleAddItem = (formData) => {
    const itemIndex = rows.findIndex((item) => item.id === formData.id);

    if (itemIndex > -1) {
      const updatedRows = rows.map((item, index) => {
        if (index === itemIndex) {
          return {
            ...item,
            companyName: formData.companyName,
            companyContacEmail: formData.companyContacEmail,
            companyAdressPhone: formData.companyAdressPhone,
            stausService: formData.stausService,
            companyActividad: formData.companyActividad,
            integrationServicesBicciIsActive:
              formData.integrationServicesBicciIsActive,
            integrationServicesBicciID: formData.integrationServicesBicciID,
          };
        }
        return item;
      });
      setRows(updatedRows);
    } else {
      const newItem = {
        id: formData.id || rows.length + 1,
        companyName: formData.companyName,
        companyContacEmail: formData.companyContacEmail,
        companyAdressPhone: formData.companyAdressPhone,
        stausService: formData.stausService,
        companyActividad: formData.companyActividad,
        integrationServicesBicciIsActive:
          formData.integrationServicesBicciIsActive,
        integrationServicesBicciID: formData.integrationServicesBicciID,
      };
      setRows([...rows, newItem]);
    }
  };

  const handleSave = async (formData) => {
    console.log(formData);

    const caracteresValidos =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    const generarCadenaAleatoria = (longitud) => {
      let resultado = "";
      for (let i = 0; i < longitud; i++) {
        const indice = Math.floor(Math.random() * caracteresValidos.length);
        resultado += caracteresValidos.charAt(indice);
      }
      return resultado;
    };

    // Función para crear o actualizar un único documento
    const upsertDocument = async (docData) => {
      let id = docData.id || generarCadenaAleatoria(10);
      if (!docData.id || docData.id === "") {
        docData.id = id;
        docData.servicio_id = id; // Asumiendo que quieres asignar el mismo ID generado a servicio_id
      }

      const collRef = collection(db, process.env.REACT_APP_COL_COMPANIES);
      const docRef = doc(collRef, id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, docData);
        console.log("Documento actualizado con éxito.");
      } else {
        await setDoc(docRef, docData);
        console.log("Documento creado con éxito.");
      }

      handleAddItem(docData); // Asumiendo que esto actualiza la UI adecuadamente
    };

    if (Array.isArray(formData)) {
      // Si formData es un arreglo, procesa cada objeto individualmente
      for (const item of formData) {
        await upsertDocument(item);
      }
    } else {
      await upsertDocument(formData);
    }

    setOpen(false);
    setOpenEdit(false);
  };
  // Formolario edit

  // Formolario ver edit
  const formFieldsEdit = [
    { variable: "id", label: "id", type: "string" },
    { variable: "companyName", label: "companyName", type: "string" },
    {
      variable: "companyContacEmail",
      label: "companyContacEmail",
      type: "string",
    },
    {
      variable: "companyAdressPhone",
      label: "companyAdressPhone",
      type: "string",
    },
    { variable: "companyActividad", label: "companyActividad", type: "string" },
    {
      variable: "integrationServicesBicciID",
      label: "integrationServicesBicciID",
      type: "string",
    },
    {
      variable: "integrationServicesBicciIsActive",
      label: "integrationServicesBicciIsActive",
      type: "boolean",
    },
  ];

  const handleViewItem = (formData) => {
    const newItem = {
      id: rows.length + 1,
      userName: formData.userName,
      userLastName: formData.userLastName,
    };
    setRows([...rows, newItem]);
  };

  const createReportByData = () => {
    console.log("Crear reporte");
    generateReportByData(bodyItems);
  };

  return (
    <div>
      <Typography variant={"h2"} sx={{ color: "#F8F8F8" }}>
        Gestionar Empresas
      </Typography>
      {/* // Formolario Nuevo Item */}
      <Button
        variant="outline"
        startIcon={<AddCircleIcon />}
        onClick={() => setOpen(true)}
        sx={{ mb: 2, color: "#f8f8f8" }} // margen inferior para separar del DataGrid
      >
        Agregar ítem
      </Button>
      <Button
        variant="outline"
        startIcon={<DownloadIcon />}
        onClick={() => createReportByData()}
        sx={{ mb: 2, color: "#f8f8f8" }} // margen inferior para separar del DataGrid
      >
        Exportar
      </Button>
      <ReusableVewData
        open={open}
        handleClose={() => setOpen(false)}
        formFields={formFields}
        initialValues={initialValues}
      />
      {/* // Formolario view Item */}
      <ReusableFormEdit
        open={openEdit}
        handleClose={() => setOpenEdit(false)}
        formFields={formFieldsEdit}
        handleSave={handleSave}
        initialValues={initialValues}
      />
      {/* // Formolario View Item */}
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        className={classes.root}
        groupingModel={["companyName"]}
      ></DataGrid>
    </div>
  );
};

export default AdminCompanies;
